const Support = () => {
  return (
    <div style={{ maxWidth: "600px", margin: "0 auto" }}>
      <h2>Santa Flyover – Support</h2>

      <form
        name="support"
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="support" />
        <p hidden>
          <label>
            Don’t fill this out if you’re human: <input name="bot-field" />
          </label>
        </p>

        <label>
          Message
          <br />
          <textarea
            name="message"
            required
            style={{ width: "100%", height: "120px" }}
          />
        </label>

        <br /><br />

        <button type="submit">Send</button>
      </form>
    </div>
  )
}

export default Support
